module.exports = __webpack_public_path__ + "static/media/john.9212634d.png";